import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pick",
  "use": "icon-pick-usage",
  "viewBox": "0 0 20 21",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 21\" id=\"icon-pick\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M16.667 10.135a6.667 6.667 0 1 1-13.333 0 6.667 6.667 0 0 1 13.333 0Zm1.667 0a8.333 8.333 0 1 1-16.667 0 8.333 8.333 0 0 1 16.667 0ZM10 5.887l3.535 3.535-1.178 1.179-1.524-1.524V14.3H9.167V9.077L7.644 10.6 6.465 9.422l3.536-3.535Z\" fill=\"#000\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol